export default {
  midia: {
    title: 'Entrega com Alta Performance e Comprometimento',
    descriptionFirst:
      'Nós fomos destaques nos principais canais de comunicação do país, o que comprova a nossa experiência e expertise quando o assunto é tecnologia.',
    descriptionSecond: 'Confira todas as manchetes!',
    button: 'saiba mais',
  },
}
